import { render, staticRenderFns } from "./RuningTips.vue?vue&type=template&id=3de19422&"
import script from "./RuningTips.vue?vue&type=script&lang=js&"
export * from "./RuningTips.vue?vue&type=script&lang=js&"
import style0 from "./RuningTips.vue?vue&type=style&index=0&id=3de19422&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports